(function () {
    'use strict';

    angular
        .module('app')
        .controller('EntitySelectionListCtrl', EntitySelectionListCtrl);

    EntitySelectionListCtrl.$inject = ['DialogInstance', 'pageHeading', 'entityList'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for selecting an entity from a supplied list.
     */
    function EntitySelectionListCtrl(DialogInstance, pageHeading, entityList) {
        /* jshint validthis:true */
        var vm = this;
        vm.pageHeading = pageHeading;
        vm.entityList = entityList;
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        function activate() {
            if (entityList.length > 0) {
                vm.selectedEntityId = entityList[0].Id;
            }
        }

        function ok() {
            DialogInstance.ok(vm.selectedEntityId);
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
